import { Link } from 'react-router-dom';
import AccountLayout from '@/components/feature/AccountLayout';
import { assets, transactions } from '@/mocks/transactions';
import { goldTypes } from '@/mocks/goldPrices';

export default function Dashboard() {
  const totalValue = assets.reduce((s, a) => s + a.quantity * a.currentPrice, 0);
  const profit = assets.reduce((s, a) => s + (a.currentPrice - a.buyPrice) * a.quantity, 0);

  return (
    <AccountLayout>
      <div className="max-w-5xl mx-auto">
        <h1 className="text-2xl font-bold text-foreground-950 mb-6">Bảng điều khiển</h1>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
          <div className="rounded-xl border border-background-200/60 bg-background-100 p-5">
            <div className="flex items-center gap-2 text-foreground-600 text-xs mb-1">
              <i className="ri-copper-coin-line text-base"></i> Tổng tài sản
            </div>
            <p className="text-xl md:text-2xl font-bold text-gold-gradient whitespace-nowrap">{totalValue.toLocaleString('vi-VN')}đ</p>
          </div>
          <div className="rounded-xl border border-background-200/60 bg-background-100 p-5">
            <div className="flex items-center gap-2 text-foreground-600 text-xs mb-1">
              <i className="ri-line-chart-line text-base"></i> Lợi nhuận
            </div>
            <p className={`text-xl md:text-2xl font-bold whitespace-nowrap ${profit >= 0 ? 'text-emerald-500' : 'text-rose-500'}`}>
              {profit >= 0 ? '+' : ''}{profit.toLocaleString('vi-VN')}đ
            </p>
          </div>
          <div className="rounded-xl border border-background-200/60 bg-background-100 p-5">
            <div className="flex items-center gap-2 text-foreground-600 text-xs mb-1">
              <i className="ri-wallet-3-line text-base"></i> Số dư khả dụng
            </div>
            <p className="text-xl md:text-2xl font-bold text-foreground-950 whitespace-nowrap">256.400.000đ</p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2 space-y-6">
            <div className="rounded-xl border border-background-200/60 bg-background-100 p-5">
              <div className="flex items-center justify-between mb-4">
                <h2 className="text-sm font-semibold text-foreground-950">Giao dịch gần đây</h2>
                <Link to="/tai-san" className="text-xs font-semibold text-primary-400 hover:text-primary-300 cursor-pointer whitespace-nowrap">Xem tất cả</Link>
              </div>
              <div className="space-y-3">
                {transactions.slice(0, 4).map((t) => (
                  <div key={t.id} className="flex items-center justify-between gap-3 py-2 border-b border-background-200/40 last:border-0">
                    <div className="flex items-center gap-3">
                      <div className={`w-9 h-9 rounded-md flex items-center justify-center ${
                        t.type === 'deposit' ? 'bg-emerald-500/15' : t.type === 'withdraw' ? 'bg-rose-500/15' : 'bg-primary-500/15'
                      }`}>
                        <i className={`text-base ${
                          t.type === 'deposit' ? 'ri-arrow-down-line text-emerald-400' : t.type === 'withdraw' ? 'ri-arrow-up-line text-rose-400' : 'ri-exchange-line text-primary-400'
                        }`}></i>
                      </div>
                      <div>
                        <p className="text-sm font-semibold text-foreground-950">{t.label}</p>
                        <p className="text-xs text-foreground-600">{t.date}</p>
                      </div>
                    </div>
                    <span className={`text-sm font-semibold whitespace-nowrap ${t.amount >= 0 ? 'text-emerald-500' : 'text-rose-500'}`}>
                      {t.amount >= 0 ? '+' : ''}{t.amount.toLocaleString('vi-VN')}đ
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="space-y-6">
            <div className="rounded-xl border border-background-200/60 bg-background-100 p-5">
              <h2 className="text-sm font-semibold text-foreground-950 mb-4">Giá vàng nổi bật</h2>
              <div className="space-y-3">
                {goldTypes.slice(0, 4).map((g) => (
                  <div key={g.id} className="flex items-center justify-between text-sm">
                    <span className="text-foreground-700 whitespace-nowrap">{g.code}</span>
                    <span className={`font-semibold whitespace-nowrap ${g.change >= 0 ? 'text-emerald-500' : 'text-rose-500'}`}>
                      {g.sell.toLocaleString('vi-VN')}đ
                    </span>
                  </div>
                ))}
              </div>
              <Link to="/thi-truong" className="mt-4 block text-center text-xs font-semibold text-primary-400 hover:text-primary-300 cursor-pointer">Xem thị trường →</Link>
            </div>

            <div className="rounded-xl border border-primary-500/30 bg-gradient-to-br from-background-100 to-primary-500/10 p-5">
              <h3 className="text-sm font-semibold text-foreground-950 mb-2">Bắt đầu giao dịch</h3>
              <p className="text-xs text-foreground-600 mb-4">Mua bán vàng với giá thời gian thực.</p>
              <Link to="/giao-dich" className="block text-center px-4 py-2.5 rounded-md bg-primary-500 text-background-950 text-sm font-semibold hover:bg-primary-600 whitespace-nowrap cursor-pointer transition-colors">
                Giao dịch ngay
              </Link>
            </div>
          </div>
        </div>
      </div>
    </AccountLayout>
  );
}